import JsonEditor from '../JsonEditor'
import OutputJSONata from '../OutputJSONata'
import JSONataScriptEditor from '../JSONataScriptEditor'
import RuleIcon from '@mui/icons-material/Rule';
import MenuIcon from '@mui/icons-material/Menu';
import { Feedback } from 'components/lib';
import _ from 'lodash';
import failedAttemptSound from 'assets/sounds/try-again.mp3';
import { Panel, PanelResizeHandle, PanelGroup } from 'react-resizable-panels';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import { useContext, useEffect, useState } from 'react';
import { AppBar, Box, IconButton, Toolbar, Tooltip, Typography } from '@mui/material';
import { useRef } from 'react';
import { ArrowBackIosNew, ArrowForwardIosRounded } from '@mui/icons-material';
import { Bindings } from '../Bindings';
import Styles from './JSONataPanel.module.scss'
import { AuthContext, useAPI, useNavigate, useParams, ViewContext } from 'components/lib';
import axios from 'axios';
import NodeProgress from 'components/global/NodeLayout/NodeProgress/NodeProgress';
import { ConfirmationCard } from 'components/global/ConfirmationCard/ConfirmationCard';
import { LightTooltip } from 'components/global/NodeLayout/NodeTopostman';
import { decoder } from 'utils/helpers/decoder';
import { BackConfirmationCard } from 'components/global/BackConfirmationCard/BackConfirmationCard';
import { LoadingBackdrop } from 'components/global/LoadingBackdrop/LoadingBackdrop';
import { InstructionsPane } from '../InstructionsPane/InstructionsPane';
import { toast, ToastContainer } from 'react-toastify';
import { Joyride } from 'components/walkthrough/walkthrough';
import { Python3Parser } from 'dt-python-parser/dist/parser';
import { StepsDrawer } from 'views/CodeEditor/components';
import { JSONataEditorContext } from '../../contexts/JSONataEditorContext';
import InfoDrawer from 'components/global/NodeLayout/InfoDrawer';

const finalAudio = `${process.env.REACT_APP_GLOBAL_MEDIA_URL}/media/git/voice/finish_node.mp3`;


export function JSONataPanel(props) {
    const navigate = useNavigate();
    const outputPanelRef = useRef(null);
    const [steps, setSteps] = useState();
    const activityTimerRef = useRef(null);
    const [isOutputCollapsed, setIsOutputCollapsed] = useState(true)
    const [nodeInfo, setNodeInfo] = useState();
    const [userInput, setUserInput] = useState('');
    const { output, setOutput, script, setScript, value, setValue, } = useContext(JSONataEditorContext)
    const [showFinishConfirm, setShowFinishConfirm] = useState(false);
    const [isExecuted, setIsExecuted] = useState(false);
    const [nodeFinished, setNodeFinished] = useState(false);
    const { lab_id } = useParams();
    const { node_id } = useParams();
    const { resource } = useParams();
    const parser = new Python3Parser();
    const [sessionId, setSessionId] = useState('');
    const { data, loading } = useAPI(`/api/labs/${lab_id}/nodes/${node_id}/${resource}`, 'GET');
    const [currentStep, setCurrentStep] = useState(0);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const roundedPercentage = nodeFinished ? 100 : Math.ceil(currentStep / nodeInfo?.numOfSteps * 100);
    const [showReveal, setShowReveal] = useState(false);
    const [maxUnlocked, setMaxUnlocked] = useState(0);
    const viewContext = useContext(ViewContext);
    const context = useContext(AuthContext);
    const [showReloadConfirm, setShowReloadConfirm] = useState(false);
    const [startLab, setStartLab] = useState(true);
    const [watcherData, setWatcherData] = useState([]);
    const [isMuted, setIsMuted] = useState(true);
    const wastedAttemptAudio = new Audio(failedAttemptSound);
    const [metadata, setMetadata] = useState(null);
    const [instructOpen, setInstructOpen] = useState(true);
    const instructPanelRef = useRef(null)
    const [layoutConfig, setLayoutConfig] = useState({
        showInstructions: true,
        showPreviewDialog: false,
        showTerminal: true,
        showDbViewer: false,
        showStepsDrawer: false,
        showInfoDrawer: false,
        showApiDrawer: false,
        showContainerDomain: false,
        showFinishConfirm: false
    });
    const toggleLayoutState = (key) => {
        setLayoutConfig((prev) => ({ ...prev, [key]: !prev[key] }));
    };

    const setLayoutState = (key, value) => {
        setLayoutConfig((prev) => ({ ...prev, [key]: value }));
    };
    const handleStepClick = (index) => {
        setCurrentStep(index);
        setLayoutState('showStepsDrawer', false) // Close drawer on selection
    };

    useEffect(() => {
        setMaxUnlocked(prev => Math.max(prev, currentStep));
    }, [currentStep]);
    useEffect(() => {
        if (data) {
            const jsonData = decoder(data);
            setMetadata(jsonData.steps_metadata)
            jsonData.numOfSteps = jsonData.steps.steps.length;
            setNodeInfo(jsonData);
            setSteps(jsonData.steps.steps);
            document.title = props.t('Labs.Nodes.NodeJSONata.title', { nodeName: jsonData.name })
            if (jsonData?.steps?.steps[currentStep]?.fileTree) {
                setWatcherData(jsonData.steps.steps[currentStep]?.fileTree)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);
    useEffect(() => {
        if (steps) {
            if (steps[currentStep]?.input_json) {
                const key = steps[currentStep]?.input_json
                const parsed = metadata[key]
                const json_val = JSON.stringify(parsed, null, 2)
                setValue(json_val)
            } else {
                setValue("{}")
            }
            const audioElement = new Audio(`${process.env.REACT_APP_GLOBAL_MEDIA_URL}${steps[currentStep]?.voice}`);
            const finalAudioElement = new Audio(finalAudio);
            if (nodeFinished) {
                audioElement?.pause();
                finalAudioElement.play();
            } else if (!isMuted) {
                audioElement?.play();
            }
            return () => {
                audioElement?.pause();
                finalAudioElement.pause();
            };
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentStep, isMuted, nodeFinished]);

    const navigateBack = () => {
        navigate(-1);
    };


    const startLabClick = async () => {
        const options = {
            method: 'POST',
            url: `/api/user/labs/${lab_id}/nodes/${node_id}/start`,
            headers: {
                accept: 'application/json',
            }
        };
        await axios
            .request(options)
            .then((response) => {
                new Promise((resolve) => setTimeout(resolve, 100));
                setStartLab(false);
                if (context?.user?.stop_walkthrough?.includes(nodeInfo?.resource?.lab_resource_id) || nodeInfo.is_assessment === 1) {
                    setIsMuted(!isMuted)
                }
                setSessionId(response.data.session_id);
            })
            .catch((err) => {
                if (err.response.status === 403) {
                    navigate('/nopermission');
                } else {
                    navigate('/oops');
                }
            });
    };
    const resetWalkthrough = (data) => {
        if (data.status === 'finished' | data.action === 'skip' | data.action === 'tour:end') {
            setIsMuted(!isMuted)
        }
    }
    const moveToNext = () => {
        if (currentStep === nodeInfo.numOfSteps - 1) {
            if (maxUnlocked === nodeInfo.numOfSteps - 1) setMaxUnlocked(prev => prev + 1)
            setNodeFinished(true);
            return;
        }
        setCurrentStep(currentStep + 1);
        if (steps[currentStep]?.fileTree) {
            setWatcherData(steps[currentStep]?.fileTree)
        }
    };
    const toggleOutputPanel = () => {
        if (outputPanelRef.current) {
            if (outputPanelRef.current.isCollapsed()) {
                outputPanelRef.current.expand();
            } else {
                outputPanelRef.current.collapse()
            }
        }
    }
    const handleDrawer = () => {
        setDrawerOpen(!drawerOpen);
    };
    function handleInactivity() {
        setShowReloadConfirm(true);
    }
    const startActivityTimer = () => {
        activityTimerRef.current = setTimeout(handleInactivity, 3600000);
    };
    const resetActivityTimer = () => {
        clearTimeout(activityTimerRef.current);
        startActivityTimer();
    };
    const handleVoiceClick = () => {
        resetActivityTimer();
        setIsMuted(!isMuted);
    };
    const checkAndProceed = (userInput, userOutput) => {
        const { isOutput, isInput } = steps[currentStep]?.exp_output === "" ? { isOutput: true, isInput: false } : validate(userOutput, userInput)
        if (!isOutput || isInput) {
            handleIncorrectAttempt();
            return;
        }
        moveToNext();
        setIsExecuted(false);
        clearEditorCode();

    };


    const handleConfirmClick = () => {
        handleFinish();
    }
    const showConfirm = () => {
        setShowFinishConfirm(true);
    }

    function handleIncorrectAttempt() {
        wastedAttemptAudio.play();
        toast.dark(props.t('Labs.Nodes.NodeJSONata.toast.error'), {
            type: 'error',
            position: 'top-right',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    }
    const clearEditorCode = () => {
        setScript('')
        setOutput('')
    };
    const validate = (output, input) => {
        const outputTokens = parser.getAllTokens(output + '\r\n');
        const outputTokensArray = outputTokens
            .map((obj) => obj['text'])
            .filter((text) => text.trim() !== '' && text !== '\r\n');
        const inputTokens = parser.getAllTokens(input + '\r\n');
        const inputTokensArray = inputTokens
            .map((obj) => obj['text'])
            .filter((text) => text.trim() !== '' && text !== '\r\n');
        const expectedOutputTokens = parser.getAllTokens(steps[currentStep].exp_output + '\r\n');
        const expectedOutputArray = expectedOutputTokens
            .map((obj) => obj['text'])
            .filter((text) => text.trim() !== '' && text !== '\r\n');
        const sanitize = (arr) => arr.map(t => { if (typeof t === "string") { return t.replace(/"/g, '') } return t });
        const isOutputEqual = _.isEqual(_.sortBy(sanitize(expectedOutputArray)), _.sortBy(sanitize(outputTokensArray)))
        const isInputEqual = _.isEqual(_.sortBy(sanitize(expectedOutputArray)), _.sortBy(sanitize(inputTokensArray)))
        return { isOutput: isOutputEqual, isInput: isInputEqual };
    };
    const handleFinish = () => {
        const options = {
            method: 'POST',
            url: `/api/user/labs/${lab_id}/nodes/${node_id}/end`,
            headers: {
                accept: 'application/json',
            },
            ...(nodeInfo.is_assessment === 1 && { data: { completionPercent: roundedPercentage } }),
        };
        axios
            .request(options)
            .then(async function (response) {
                await new Promise((resolve) => setTimeout(resolve, 50)); // Adding a wait for api post to happen
                if (nodeInfo?.is_assessment) {
                    navigate(`/labs/${lab_id}/nodes`);
                } else {
                    navigate(`/labs/${lab_id}/nodes/${node_id}/quiz/attempt`);
                }
            })
            .catch((err) => {
                let status = err.response.status;
                console.log('error', status);
                navigate('/oops');
            });
    };
    return (
        <>
            {loading ? (
                <div>
                    <LoadingBackdrop isOpen={true} />
                </div>
            ) : steps ? (
                <>
                    <ToastContainer
                        id="warning-toast"
                        position="top-right"
                        autoClose={10000}
                        hideProgressBar={false}
                        newestOnTop
                        closeOnClick
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        limit={4}
                    />
                    <BackConfirmationCard
                        isSaveAvailable={true}
                    />
                    <ConfirmationCard
                        title={
                            nodeInfo.is_assessment ?
                                props.t("Labs.Nodes.NodeJSONata.confirm.start.assessment.title")
                                : props.t("Labs.Nodes.NodeJSONata.confirm.start.default.title")
                        }
                        body={
                            nodeInfo.is_assessment ?
                                props.t("Labs.Nodes.NodeJSONata.confirm.start.assessment.body")
                                : props.t("Labs.Nodes.NodeJSONata.confirm.start.default.body")
                        }
                        showCard={startLab}
                        setShowCard={setStartLab}
                        handleCancel={navigateBack}
                        handleConfirm={startLabClick}
                    />
                    {!startLab && nodeInfo.is_assessment !== 1 ? (
                        <Joyride
                            open={nodeInfo?.resource?.walkthrough?.open}
                            run={nodeInfo?.resource?.walkthrough?.run}
                            steps={nodeInfo?.resource?.walkthrough?.steps || []}
                            resourceId={nodeInfo?.resource?.lab_resource_id}
                            disableOverlay={true}
                            callback={resetWalkthrough}
                        />
                    ) : null}
                    <div id="titleContainer" className={Styles.titleContainer}>
                        <div style={{ display: 'flex' }}>
                            <Tooltip title="Steps" arrow>
                                <IconButton
                                    id='stepsToggle'
                                    size="large"
                                    edge="start"
                                    color="white"
                                    aria-label="menu-item"
                                    onClick={() => toggleLayoutState('showStepsDrawer')}
                                    sx={{
                                        transition: 'all 0.3s',
                                    }}
                                >
                                    <MenuIcon style={{ color: "white" }} />
                                </IconButton>
                            </Tooltip>
                            <StepsDrawer
                                open={layoutConfig.showStepsDrawer}
                                onClose={() => toggleLayoutState('showStepsDrawer')}
                                steps={steps}
                                onStepClick={handleStepClick}
                                totalSteps={nodeInfo?.numOfSteps}
                                currentStep={currentStep}
                                nodeFinished={nodeFinished}
                                maxUnlocked={maxUnlocked}
                            />
                            <Typography
                                variant="h3"
                                sx={{
                                    textTransform: 'uppercase',
                                    color: '#76EAD7',
                                }}
                            >
                                {nodeInfo.name}
                            </Typography>
                        </div>
                        <span style={{ display: 'flex', flexDirection: 'row' }}>
                            <button
                                id="verifyButton"
                                className={`${Styles.ButtonStyles}`}
                                // disabled={!isExecuted}
                                onClick={() => { checkAndProceed(script, output); }}
                                title={isExecuted ? '' : props.t('Labs.Nodes.NodeJSONata.tooltip.verify')}
                            >
                                {props.t('Labs.Nodes.NodeJSONata.button.verify')}
                                <RuleIcon fontSize='small' />
                            </button>
                            <LightTooltip
                                title={
                                    nodeInfo.is_assessment
                                        ? ((roundedPercentage > 70) || nodeFinished ?
                                            props.t('Labs.Nodes.NodeJSONata.tooltip.finish.done')
                                            : props.t('Labs.Nodes.NodeJSONata.tooltip.finish.assessment')
                                        )
                                        : (nodeFinished ?
                                            props.t('Labs.Nodes.NodeJSONata.tooltip.finish.done')
                                            : props.t('Labs.Nodes.NodeJSONata.tooltip.finish.info')
                                        )
                                }
                                arrow
                                placement="left"
                                classes={{
                                    tooltip: {
                                        backgroundColor: '#fff',
                                        color: 'rgba(0, 0, 0, 0.87)',
                                        boxShadow: '0 2px 5px rgba(0, 0, 0, 0.15)',
                                        fontSize: 11,
                                    },
                                }}
                            >
                                <span>
                                    <button
                                        id="finishButton"
                                        variant="extended"
                                        className={Styles.finishButton}
                                        onClick={() => {
                                            nodeInfo.is_assessment ? showConfirm() : handleFinish()
                                        }}
                                        disabled={
                                            !nodeInfo.is_assessment
                                                ? !nodeFinished
                                                : roundedPercentage < 70
                                        }
                                    >
                                        <KeyboardDoubleArrowRightIcon />
                                        {props.t('Labs.Nodes.NodeJSONata.button.finish')}
                                    </button>
                                </span>
                            </LightTooltip>
                            <ConfirmationCard
                                title={
                                    (roundedPercentage > 70 && roundedPercentage < 100) ?
                                        props.t('Labs.Nodes.NodeJSONata.confirm.completed.title.warn')
                                        : props.t('Labs.Nodes.NodeJSONata.confirm.completed.title.default')
                                }
                                body={(roundedPercentage > 70 && roundedPercentage < 100) ?
                                    props.t('Labs.Nodes.NodeJSONata.confirm.completed.body.warn')
                                    : props.t('Labs.Nodes.NodeJSONata.confirm.completed.body.default')
                                }
                                showCard={showFinishConfirm}
                                setShowCard={setShowFinishConfirm}
                                handleConfirm={handleConfirmClick}
                            />
                            {<NodeProgress
                                lab_id={lab_id}
                                node_id={node_id}
                                currentStep={currentStep}
                                setDrawerOpen={setDrawerOpen}
                                drawerOpen={drawerOpen}
                                setCurrentStep={setCurrentStep}
                                initialUserProgress={nodeInfo.userProgress}
                                steps={steps}
                                data={data}
                                resource={nodeInfo?.resource}
                                onReveal={() => setShowReveal(true)}
                                nodeInfo={nodeInfo}
                                maxUnlocked={maxUnlocked}
                                setMaxUnlocked={setMaxUnlocked}
                                sessionId={sessionId}
                            />
                            }
                            {<InfoDrawer
                                handleDrawer={handleDrawer}
                                drawerOpen={drawerOpen}
                                titleText={props.t('Labs.Nodes.NodeJSONata.reference', { LabName: nodeInfo.labName })}
                                displayData={nodeInfo?.content?.reference_data}
                            />}
                        </span>
                    </div>
                    <div style={{ position: 'relative', height: '90%', width: '100%', marginTop: '1em' }}>
                        <PanelGroup direction="horizontal" style={{ height: '100%', width: '100%', borderRadius: '4px', borderWidth: '10px' }}>
                            <Panel defaultSize={70}>
                                <PanelGroup direction="vertical" style={{ height: '100%', width: '100%', right: '60px', paddingLeft: '10px' }}>
                                    <Panel defaultSize={40} minSize={25}>
                                        <div className={Styles.mainPanelDiv}>
                                            <PanelGroup direction='horizontal'>
                                                <Panel defaultSize={50} minSize={25}>
                                                    <AppBar id="jsonataScript" position='static' elevation={0}>
                                                        <Toolbar sx={{
                                                            minHeight: '34px !important',
                                                            background: 'linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%)',
                                                            borderBottom: '1px solid rgba(255, 255, 255, 0.15)',
                                                            boxShadow: '0 2px 8px rgba(30, 58, 138, 0.15)'
                                                        }}>
                                                            <Typography sx={{
                                                                color: 'white',
                                                                fontWeight: 600,
                                                                fontSize: '0.875rem',
                                                                letterSpacing: '0.5px',
                                                                textShadow: '0 1px 2px rgba(0, 0, 0, 0.1)'
                                                            }}>
                                                                {props.t("Labs.Nodes.NodeJSONata.panel.topLeft")}
                                                            </Typography>
                                                        </Toolbar>
                                                    </AppBar>
                                                    <div className={Styles.panelDiv}>
                                                        <JSONataScriptEditor />
                                                    </div>
                                                </Panel>
                                                <PanelResizeHandle className={Styles.resizePanelHorizontal} />
                                                <Panel ref={outputPanelRef} collapsible={true} onCollapse={() => { setIsOutputCollapsed(true) }} onExpand={() => setIsOutputCollapsed(false)} collapsedSize={5} defaultSize={5} minSize={50}>
                                                    {isOutputCollapsed ? (<Box
                                                        sx={{
                                                            height: '100%',
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            alignItems: 'center',
                                                            justifyContent: 'flex-start',
                                                            bgcolor: 'primary.main', // replaces backgroundColor
                                                            py: 1,                   // replaces padding: '8px 0'
                                                        }}
                                                    > <IconButton size='small' onClick={toggleOutputPanel}>
                                                            <ArrowBackIosNew fontSize='inherit' sx={{ color: 'white' }}></ArrowBackIosNew>
                                                        </IconButton>
                                                        <Typography sx={{
                                                            writingMode: 'vertical-rl',
                                                            color: 'white'
                                                        }}>
                                                            {props.t("Labs.Nodes.NodeJSONata.panel.topRight")}
                                                        </Typography>
                                                    </Box>) : (
                                                        <>
                                                            <AppBar id="jsonataBindings" position='static' color='primary' elevation={0}>
                                                                <Toolbar sx={{
                                                                    minHeight: '34px !important',
                                                                    background: 'linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%)',
                                                                    borderBottom: '1px solid rgba(255, 255, 255, 0.15)',
                                                                    boxShadow: '0 2px 8px rgba(30, 58, 138, 0.15)'
                                                                }}>
                                                                    <IconButton size='small' onClick={toggleOutputPanel}>
                                                                        <ArrowForwardIosRounded fontSize='inherit' sx={{ color: 'white' }}></ArrowForwardIosRounded>
                                                                    </IconButton>
                                                                    <Typography sx={{
                                                                        color: 'white',
                                                                        fontWeight: 600,
                                                                        fontSize: '0.875rem',
                                                                        letterSpacing: '0.5px',
                                                                        textShadow: '0 1px 2px rgba(0, 0, 0, 0.1)'
                                                                    }}>
                                                                        {props.t("Labs.Nodes.NodeJSONata.panel.topRight")}
                                                                    </Typography>
                                                                </Toolbar>
                                                            </AppBar>
                                                            <div className={Styles.panelDiv}>
                                                                <Bindings />
                                                            </div>
                                                        </>)}
                                                </Panel>
                                            </PanelGroup>
                                        </div>
                                    </Panel>
                                    <PanelResizeHandle className={Styles.resizePanelVertical} />
                                    <Panel defaultSize={60} minSize={25}>
                                        <div className={Styles.mainPanelDiv}>
                                            <PanelGroup direction="horizontal">
                                                <Panel defaultSize={50} minSize={25}>
                                                    <AppBar id="jsonataJson" position='static'>
                                                        <Toolbar sx={{
                                                            minHeight: '34px !important',
                                                            background: 'linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%)',
                                                            borderBottom: '1px solid rgba(255, 255, 255, 0.15)',
                                                            boxShadow: '0 2px 8px rgba(30, 58, 138, 0.15)'
                                                        }}>
                                                            <Typography sx={{
                                                                color: 'white',
                                                                fontWeight: 600,
                                                                fontSize: '0.875rem',
                                                                letterSpacing: '0.5px',
                                                                textShadow: '0 1px 2px rgba(0, 0, 0, 0.1)'
                                                            }}>
                                                                {props.t("Labs.Nodes.NodeJSONata.panel.bottomLeft")}
                                                            </Typography>
                                                        </Toolbar>
                                                    </AppBar>
                                                    <div className={Styles.panelDiv}>
                                                        <JsonEditor />
                                                    </div>
                                                </Panel>
                                                <PanelResizeHandle className={Styles.resizePanelHorizontal} />
                                                <Panel defaultSize={50} minSize={25}>
                                                    <AppBar id="jsonataOutput" position='static'>
                                                        <Toolbar sx={{
                                                            minHeight: '34px !important',
                                                            background: 'linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%)',
                                                            borderBottom: '1px solid rgba(255, 255, 255, 0.15)',
                                                            boxShadow: '0 2px 8px rgba(30, 58, 138, 0.15)'
                                                        }}>
                                                            <Typography sx={{
                                                                color: 'white',
                                                                fontWeight: 600,
                                                                fontSize: '0.875rem',
                                                                letterSpacing: '0.5px',
                                                                textShadow: '0 1px 2px rgba(0, 0, 0, 0.1)'
                                                            }}>
                                                                {props.t("Labs.Nodes.NodeJSONata.panel.bottomRight")}
                                                            </Typography>
                                                        </Toolbar>
                                                    </AppBar>
                                                    <div className={Styles.panelDiv}>
                                                        <OutputJSONata />
                                                    </div>
                                                </Panel>
                                            </PanelGroup>
                                        </div>
                                    </Panel>
                                </PanelGroup>
                            </Panel>
                            <Panel ref={instructPanelRef} defaultSize={30} collapsible={true} onCollapse={() => { setInstructOpen(false) }} onExpand={() => { setInstructOpen(true) }} collapsedSize={5}>
                                <InstructionsPane
                                    steps={steps}
                                    isMuted={isMuted}
                                    currentStep={currentStep}
                                    handleVoiceClick={handleVoiceClick}
                                    nodeInfo={nodeInfo}
                                    open={instructOpen}
                                    onToggle={(next) => {
                                        if (next) instructPanelRef.current?.expand();
                                        else instructPanelRef.current?.collapse();
                                    }}
                                    t={props.t}
                                />
                            </Panel>
                        </PanelGroup>
                    </div>
                </>) : (
                <div>
                    <LoadingBackdrop isOpen={true} />
                </div>
            )
            }
            {nodeFinished && <Feedback isInNode={true} nodeName={nodeInfo.name} labName={nodeInfo.labName} />}

        </>
    )

}


